import { render, staticRenderFns } from "./MetricDescription.vue?vue&type=template&id=620b78cd&scoped=true"
import script from "./MetricDescription.vue?vue&type=script&lang=js"
export * from "./MetricDescription.vue?vue&type=script&lang=js"
import style0 from "./MetricDescription.vue?vue&type=style&index=0&id=620b78cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b78cd",
  null
  
)

export default component.exports